export const FILE_EXTENSION_GROUPS = {
  pdf: ["pdf"],
  doc: ["docx", "doc", "txt", "txtplain"],
  image: ["jpg", "jpeg", "png"],
  excel: ["xlsx", "xls", "csv"],
  ppt: ["ppt"],
};
export const CONTACT_MAIL = "support.conformite@legal2digital.fr";
